export const formatMoney = (cents: number, currency = 'CAD'): string =>
  new Intl.NumberFormat('en-CA', { style: 'currency', currency }).format(cents / 100);

/** Durations read as m:ss so they stack cleanly in a column. */
export function formatDuration(seconds: number): string {
  if (seconds < 60) return `0:${String(seconds).padStart(2, '0')}`;
  const minutes = Math.floor(seconds / 60);
  return `${minutes}:${String(seconds % 60).padStart(2, '0')}`;
}

export const formatTime = (iso: string): string =>
  new Date(iso).toLocaleTimeString('en-CA', { hour: 'numeric', minute: '2-digit' });

export const formatDateTime = (iso: string): string =>
  new Date(iso).toLocaleString('en-CA', {
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit'
  });

/** +14165551234 -> (416) 555-1234 */
export function formatPhone(value: string): string {
  if (value.startsWith('+1') && value.length === 12) {
    return `(${value.slice(2, 5)}) ${value.slice(5, 8)}-${value.slice(8)}`;
  }
  return value;
}

/**
 * Telnyx and our validators only accept E.164, but people type numbers the way
 * they say them. Ten digits are North American, so they get a +1.
 */
export function toE164(value: string): string {
  const trimmed = value.trim();
  if (trimmed.startsWith('+')) return `+${trimmed.slice(1).replace(/\D/g, '')}`;

  const digits = trimmed.replace(/\D/g, '');
  if (digits.length === 10) return `+1${digits}`;
  if (digits.length === 11 && digits.startsWith('1')) return `+${digits}`;
  return digits ? `+${digits}` : '';
}
